import React from 'react';
import { /* FormControl,  FormLabel, Grid, TextField */ Grid } from '@material-ui/core';
//import { LABEL_INPUT_FONT_SIZE } from '../../ConstsAndUtils/utils';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
  Typography,
} from '@material-ui/core';

const EstadoAcreditacion = props => {

  const {
    datosAcreditacion,
    numAcreditaciones,
    añoAcreditacion,
    fechaTerminoVigencia,
    numRegistroInscripcionSis,
    numeroResolucion,
    entidadAcreditadora,
  } = props;

  return (
    <Grid
      container
      item
      xs={12}
      spacing={4}
      justifyContent='center'
      style={{
        backgroundColor: 'white',
        paddingTop: 5,
        borderRadius: 5,
        paddingBottom: 5,
        marginTop: 15,
        marginLeft: 1,
        marginRight: 1
      }}>

      <TableContainer component={Paper} elevation={0}
        style={{ width: '80%' }}
      >
        <Table size="medium">
          <TableBody>
            {datosAcreditacion ? (
              <>
                <TableRow style={{ backgroundColor: '#f4f4f7' }}>
                  <TableCell
                    style={{ fontWeight: 'bold' }}
                  >Estado de acreditación</TableCell>
                  <TableCell>{datosAcreditacion.estado_actual}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{ fontWeight: 'bold' }}
                  >Nº de acreditaciones realizadas</TableCell>
                  <TableCell>{numAcreditaciones}</TableCell>
                </TableRow>

                <TableRow style={{ backgroundColor: '#f4f4f7' }}>
                  <TableCell
                    style={{ fontWeight: 'bold' }}
                  >Número de resolución</TableCell>
                  <TableCell>{numeroResolucion}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{ fontWeight: 'bold' }}
                  >Año</TableCell>
                  <TableCell>{añoAcreditacion}</TableCell>
                </TableRow>

                <TableRow style={{ backgroundColor: '#f4f4f7' }}>
                  <TableCell
                    style={{ fontWeight: 'bold' }}
                  >Fecha término de vigencia</TableCell>
                  <TableCell>{fechaTerminoVigencia}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{ fontWeight: 'bold' }}
                  >Nº de Registro de Inscripción en página WEB SIS</TableCell>
                  <TableCell>{numRegistroInscripcionSis}</TableCell>
                </TableRow>

                <TableRow style={{ backgroundColor: '#f4f4f7' }}>
                  <TableCell
                    style={{ fontWeight: 'bold' }}
                  >Entidad Acreditadora</TableCell>
                  <TableCell>{entidadAcreditadora}</TableCell>
                </TableRow>
              </>
            ) : (
              <TableRow>
                <TableCell colSpan={2}>
                  <Typography variant="body2" color="textSecondary">
                    No posee acreditaciones
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/*       <Grid container justifyContent='center' style={{ fontSize: 16 }}>
        {
          datosAcreditacion ?
            <table style={{ padding: 10 }}>
              <tbody>
                <tr><td style={{ padding: 10 }}>Estado de acreditación</td><td style={{ padding: 10 }}>{': ' + datosAcreditacion.estado_actual}</td></tr>
                <tr><td style={{ padding: 10 }}>Nº de acreditaciones realizadas</td><td style={{ padding: 10 }}>{': ' + numAcreditaciones}</td></tr>
                <tr><td style={{ padding: 10 }}>Número de resolución</td><td style={{ padding: 10 }}>{': ' + numeroResolucion}</td></tr>
                <tr><td style={{ padding: 10 }}>Año</td><td style={{ padding: 10 }}>{': ' + añoAcreditacion}</td></tr>
                <tr><td style={{ padding: 10 }}>Fecha término de vigencia</td><td style={{ padding: 10 }}>{': ' + fechaTerminoVigencia}</td></tr>
                <tr><td style={{ padding: 10 }}>Nº de Registro de Inscripción en página WEB SIS</td><td style={{ padding: 10 }}>{': ' + numRegistroInscripcionSis}</td></tr>
                <tr><td style={{ padding: 10 }}>Entidad Acreditadora</td><td style={{ padding: 10 }}>{': ' + entidadAcreditadora}</td></tr>
              </tbody>

            </table>
            :
            <table style={{ padding: 10 }}>
              <tbody>
                <tr><td style={{ padding: 10 }}>No posee acreditaciones</td></tr>
              </tbody>

            </table>
        }
      </Grid> */}


      {/*  <Grid container alignItems="center" spacing={1} style={{ padding: 8, marginBottom: 10 }}>
        <Grid item>
          <FormLabel component="legend">Estado de Acreditación: {datosAcreditacion ? datosAcreditacion.estado_actual : "No Acreditado"}</FormLabel>
        </Grid>
        <Grid item>
        </Grid>
      </Grid>


      {
        datosAcreditacion ?
          <Grid item xs={4} hidden={datosAcreditacion ? false : true}>
            <TextField
              fullWidth
              disabled
              value={numAcreditaciones}
              onChange={(e) => {
              }}
              size="small"
              variant="outlined"
              label="Nº de acreditaciones realizadas"
              InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
            />
          </Grid>
          :
          null
      }



      {
        datosAcreditacion ?
          <Grid item xs={4} hidden={datosAcreditacion ? false : true}>
            <TextField
              fullWidth
              disabled
              value={numeroResolucion}
              onChange={(e) => {
              }}
              size="small"
              variant="outlined"
              label="Número de resolución"
              InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
            />
          </Grid>
          :
          null}

      {
        datosAcreditacion ?

          <Grid item xs={4} hidden={datosAcreditacion ? false : true}>
            <TextField
              fullWidth
              disabled
              value={añoAcreditacion}
              onChange={(e) => {
              }}
              size="small"
              variant="outlined"
              label="Año"
              InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
            />
          </Grid>
          :
          null
      }

      {
        datosAcreditacion ?
          <Grid item xs={4} hidden={datosAcreditacion ? false : true}>
            <TextField
              fullWidth
              type='date'
              disabled
              value={fechaTerminoVigencia}
              onChange={(e) => {
              }}
              size="small"
              variant="outlined"
              label="Fecha término de vigencia"
              InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
            />
          </Grid>
          :
          null}

      {
        datosAcreditacion ?
          <Grid item xs={4} hidden={datosAcreditacion ? false : true}>
            <TextField
              fullWidth
              disabled
              value={numRegistroInscripcionSis}
              onChange={(e) => {
              }}
              size="small"
              variant="outlined"
              label="Nº de Registro de Inscripción en página WEB SIS"
              InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
            />
          </Grid>
          :
          null
      }

      {
        datosAcreditacion ?
          <Grid item xs={4} hidden={datosAcreditacion ? false : true}>
            <TextField
              fullWidth
              disabled
              value={entidadAcreditadora}
              onChange={(e) => {
              }}
              size="small"
              variant="outlined"
              label="Entidad Acreditadora"
              InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
            />
          </Grid>
          :
          null} */}
    </Grid>

  );
};

export default EstadoAcreditacion;
